export default "__VITE_ASSET__5hYQ7NQ$__"